import { WarningFilled } from "@ant-design/icons"
import React from "react"

// +-------------------------------------------
// | 2025-08-05 15:05:28
// | 
// +-------------------------------------------
interface WarningProps {
  color: string
  onClick?: ()=> void
}
const Warning: React.FC<WarningProps> = ({ color, onClick })=> {
  return (
    <i onClick={onClick} style={{color, marginRight: 5}}>
      <WarningFilled/>
    </i>
  )
}

interface Props {
  warningState: number
  label: string
}
const WarningState: React.FC<Props> = ({ warningState, label })=> {
  return (
    <span>
        {
          [
            null,
            null,
            <Warning color='#f39c00'/>,
            <Warning color='#f83b24'/>,
          ][warningState]
        }
        <em style={{fontStyle: 'normal'}}>{ label }</em>
      </span>
  )
}

export default WarningState